import { render, staticRenderFns } from "./policy.vue?vue&type=template&id=52b472e8&scoped=true&"
var script = {}
import style0 from "./policy.vue?vue&type=style&index=0&id=52b472e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b472e8",
  null
  
)

export default component.exports